import React from 'react'
import { Box, FormControlLabel, Switch } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import CustomTooltip from '../../components/CustomTooltip'
import { useUserRole } from '../../hooks/useUserRole'
import { ROLES } from '../../consts/roles'

const ENABLED_TOOLTIP =
  'When off, this attribute is still stored but won’t appear as an option in reporting or insights.'
const RESTRICTED_TOOLTIP =
  'Only Account Owner and System Manager can change reporting visibility.'

/**
 * Role-gated "Show on Reports" toggle for the attribute create/edit modals (CE-7).
 * Bound to the `isReportEnabled` form field (ON = `is_report_enabled: true`,
 * i.e. the attribute is shown in reporting/insights). Only Account Owner and
 * System Manager can change it; everyone else sees it disabled with a tooltip.
 */
const ReportEnabledToggle: React.FC = () => {
  const { control } = useFormContext()
  const { hasAnyRole } = useUserRole()
  const canEdit = hasAnyRole(ROLES.ACCOUNT_OWNER, ROLES.SYSTEM_MANAGER)

  return (
    <Box marginLeft={4}>
      <Controller
        name="isReportEnabled"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <CustomTooltip title={canEdit ? ENABLED_TOOLTIP : RESTRICTED_TOOLTIP}>
                <Switch
                  checked={!!field.value}
                  onChange={e => { field.onChange(e.target.checked) }}
                  disabled={!canEdit}
                  color="primary"
                />
              </CustomTooltip>
            }
            label="Show on Reports"
          />
        )}
      />
    </Box>
  )
}

export default ReportEnabledToggle
